import { ReactElement, useState } from 'react';
import DescriptionIcon from '@mui/icons-material/DescriptionOutlined';

import { NotesInput } from '../../../components/NotesInput';
import { usePostAdminNote } from '../../../hooks/useIncidentApi';
import { IncidentNote } from '../../../types/incidents';
import { StyledAdminNotesField } from '../IncidentForm.styles';

interface AdminNotesFieldProps {
  defaultValue?: IncidentNote[];
  incidentId?: number;
}

export const AdminNotesField = ({ defaultValue, incidentId }: AdminNotesFieldProps): ReactElement => {
  const [allNotes, setAllNotes] = useState<IncidentNote[]>(defaultValue || []);

  const { mutate } = usePostAdminNote(
    (data) => {
      setAllNotes([...allNotes, data]);
    },
    () => {}
  );

  return (
    <StyledAdminNotesField>
      <NotesInput
        value={allNotes}
        onSubmit={(note) => note && mutate({ id: incidentId || -1, content: note })}
        placeholder="Add an internal note about this incident"
        isLoading={false}
        title="T&S Notes (Internal)"
        titleIcon={<DescriptionIcon />}
      />
    </StyledAdminNotesField>
  );
};
